import { z } from "zod";

import type { ClientsTranslations } from "@/shared/lang/interfaces/clients";

import { MAX_EMAIL } from "./emailValidation";

const PHONE_DIGITS_REGEX = /^\d{7,15}$/;

const MIN_ORG_NAME = 2;
const MAX_ORG_NAME = 255;
const MAX_PHONE = 20;
const MAX_COUNTRY = 5;

export type EditOrganizationErrorTranslator = (key: keyof ClientsTranslations) => string;

export function createEditOrganizationSchema(t: EditOrganizationErrorTranslator) {
  return z.object({
    name: z
      .string()
      .trim()
      .min(1, t("validation_org_name_required"))
      .min(MIN_ORG_NAME, t("validation_org_name_min"))
      .max(MAX_ORG_NAME, t("validation_org_name_max")),
    email: z
      .string()
      .trim()
      .min(1, t("validation_email_required"))
      .max(MAX_EMAIL, t("validation_email_max"))
      .email(t("validation_email_invalid")),
    phone: z
      .string()
      .trim()
      .min(1, t("validation_phone_required"))
      .max(MAX_PHONE, t("validation_phone_max"))
      .refine((v) => PHONE_DIGITS_REGEX.test(v.replace(/\D/g, "")), t("validation_phone_required"))
      .transform((v) => v.replace(/\D/g, "")),
    country: z
      .string()
      .trim()
      .min(1, t("validation_country_required"))
      .max(MAX_COUNTRY, t("validation_country_required")),
  });
}

export type EditOrganizationValues = z.infer<ReturnType<typeof createEditOrganizationSchema>>;
